const initialState = {
  sent: false,
  sendError: null,
  checkError: null,
  valid: null,
};

export default function phoneVerification(state = initialState, action) {
  switch (action.type) {
    case 'SENT':
      return { ...state, sent: true, sendError: null };
    case 'SEND_ERROR':
      return { ...state, sendError: action.error };
    case 'CHECK_ERROR':
      return { ...state, checkError: action.error };
    case 'VALID':
      return {
        ...state,
        valid: action.valid,
        checkError: null,
      };
    case 'RESET':
      return {
        ...state,
        sent: false,
        sendError: null,
        checkError: null,
        valid: null,
      };
    default:
      return state;
  }
}
